import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import alertMessage from '../utils/alertMessage'
import connectionMonitorAPI from '../apis/connectionMonitorAPI'

export default class ConnectionMonitorStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  /*SearchResult start*/
  @observable searchItem = {
    channel: '',
    status: '',
    direction: '',
    channelType: '',
    partner: '',
    partnerComponent: '',
  }
  @observable connectionMonitorList = [
    {
    channelName: 'CC_RT_Mark_Order_in_HTTP_Post',
    status: 'On going',
    processStatus: 'Running',
    shortLog: 'has authorization error',
    partner: 'RT_Mark',
    partnerComponent: 'Order',
    partnerNamespace: 'https://rt_mark.com/order/po',
    processDetails: [{
      status: 'On going',
      timeStamp: '2021/04/12 12:33:23',
      messageID: '02267ff5-cde3-42be-b181-ef81bdfe3ca1',
      processLog: 'Error in response',
    },{
      status: 'On going',
      timeStamp: '2021/04/12 12:33:23',
      messageID: 'c7022bbd-ecb6-415a-a494-6b19dd212eff',
      processLog: 'call complated',
    }],
  },{
    channelName: 'CC_SAP_PO_Sales_Order_out_SOAP',
    status: 'On going',
    processStatus: 'Running',
    shortLog: '',
    partner: 'SAP_PO',
    partnerComponent: 'Sales_Order',
    partnerNamespace: '1',
    processDetails: [{
      status: 'Error',
      timeStamp: '2021/04/12 12:33:23',
      messageID: '02267ff5-cde3-42be-b181-ef81bdfe3ca1',
      processLog: 'Error in response',
    },{
      status: 'On going',
      timeStamp: '2021/04/12 12:33:23',
      messageID: 'c7022bbd-ecb6-415a-a494-6b19dd212eff',
      processLog: 'call complated',
    }],
  },{
    channelName: '1',
    status: 'Error',
    processStatus: '',
    shortLog: '',
    partner: '1',
    partnerComponent: '1',
    partnerNamespace: '1',
    processDetails: [{
      status: '',
      timeStamp: '2021/04/12 12:33:23',
      messageID: '02267ff5-cde3-42be-b181-ef81bdfe3ca1',
      processLog: 'Error in response',
    },{
      status: '',
      timeStamp: '2021/04/12 12:33:23',
      messageID: 'c7022bbd-ecb6-415a-a494-6b19dd212eff',
      processLog: 'call complated',
    }],
  }]
  @action
  async onSearchMonitorAction(params) {
    // this.isFetching = true
    // try {
    //   this.connectionMonitorList = []
    //   const response = await connectionMonitorAPI.searchAction(params,this.pageNo,this.pageSize)
    //   runInAction(() => {
    //     this.isFetching = false;
    //     if (response.code === 0) {
    //       for (var i = 0; i < response.data.list.length; i++) {
    //         response.data.list[i].status?response.data.list[i].statusName='Enable': response.data.list[i].statusName='Disable';
    //       }
    //       this.connectionMonitorList = response.data.list || []
    //       this.itemCount = response.data.total
    //     }
    //   })
    // } catch (err) {
    //   alertMessage.error(err.message)
    //   runInAction(() => {
    //     this.isFetching = false;
    //   });
    // }
  }
  /*SearchResult end*/
  /*start*/
  @action
  async onStartMonitorAction(params){
    this.isFetching = true
    try {
      const response = await connectionMonitorAPI.startAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.code === 200) {
          alertMessage.success('Add Success！')
          this.onSearchMonitorAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Add Failed！' + response.data +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*stop*/
  @action
  async onStopMonitorAction(params){
    this.isFetching = true
    try {
      const response = await connectionMonitorAPI.stopAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.code === 200) {
          alertMessage.success('Edit Success！')
          this.onSearchMonitorAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Edit Failed！' + response.data +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*schedule*/
  @action
  async onScheduleMonitorAction(params){
    this.isFetching = true
    try {
      const response = await connectionMonitorAPI.scheduleAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.code === 200) {
          alertMessage.success('Edit Success！')
          this.onSearchMonitorAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Edit Failed！' + response.data +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*PingChannel*/
  @action
  async onPingChannelMonitorAction(params){
    this.isFetching = true
    try {
      const response = await connectionMonitorAPI.pingChannelAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.code === 200) {
          alertMessage.success('Edit Success！')
          this.onSearchMonitorAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Edit Failed！' + response.data +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onSearchMonitorAction(this.searchItem,this.pageNo,this.pageSize)
  }
}
